import { render, staticRenderFns } from "./NewPropertyForm.vue?vue&type=template&id=22b19dd9&"
import script from "./NewPropertyForm.vue?vue&type=script&lang=js&"
export * from "./NewPropertyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports